import { render, staticRenderFns } from "./orderItemList.vue?vue&type=template&id=7ff9ae86&"
import script from "./orderItemList.vue?vue&type=script&lang=js&"
export * from "./orderItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports